import { getToken } from "services/auth.service";

const API_URL = `${process.env.REACT_APP_API_URL}/api/contractitemhistory`;

// Lấy lịch sử hạng mục theo hợp đồng
export const getContractItemHistory = async (
  contractId,
  pageNumber = 1,
  pageSize = 50
) => {
  try {
    const token = getToken();
    if (!token) {
      throw new Error("No authentication token found");
    }

    const response = await fetch(
      `${API_URL}/contract/${contractId}?pageNumber=${pageNumber}&pageSize=${pageSize}`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );

    if (!response.ok) {
      throw new Error("Failed to fetch contract item history");
    }

    return await response.json();
  } catch (error) {
    console.error("Error fetching contract item history:", error);
    throw error;
  }
};

// Lấy lịch sử theo hạng mục cụ thể
export const getItemHistory = async (itemId, pageNumber = 1, pageSize = 50) => {
  try {
    const token = getToken();
    if (!token) {
      throw new Error("No authentication token found");
    }

    const response = await fetch(
      `${API_URL}/item/${itemId}?pageNumber=${pageNumber}&pageSize=${pageSize}`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );

    if (!response.ok) {
      throw new Error("Failed to fetch item history");
    }

    return await response.json();
  } catch (error) {
    console.error("Error fetching item history:", error);
    throw error;
  }
};

// Lấy chi tiết một bản ghi lịch sử
export const getHistoryById = async (historyId) => {
  try {
    const token = getToken();
    if (!token) {
      throw new Error("No authentication token found");
    }

    const response = await fetch(`${API_URL}/${historyId}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      throw new Error("Failed to fetch history details");
    }

    return await response.json();
  } catch (error) {
    console.error("Error fetching history details:", error);
    throw error;
  }
};

// Lấy thống kê tổng quan lịch sử theo hợp đồng
export const getContractHistorySummary = async (contractId) => {
  try {
    const token = getToken();
    if (!token) {
      throw new Error("No authentication token found");
    }

    const response = await fetch(`${API_URL}/contract/${contractId}/summary`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      throw new Error("Failed to fetch contract history summary");
    }

    return await response.json();
  } catch (error) {
    console.error("Error fetching contract history summary:", error);
    throw error;
  }
};

// Lấy thống kê tổng quan lịch sử theo hạng mục
export const getItemHistorySummary = async (itemId) => {
  try {
    const token = getToken();
    if (!token) {
      throw new Error("No authentication token found");
    }

    const response = await fetch(`${API_URL}/item/${itemId}/summary`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      throw new Error("Failed to fetch item history summary");
    }

    return await response.json();
  } catch (error) {
    console.error("Error fetching item history summary:", error);
    throw error;
  }
};

// Thêm bản ghi lịch sử thủ công
export const addHistory = async (historyData) => {
  try {
    const token = getToken();
    if (!token) {
      throw new Error("No authentication token found");
    }

    const response = await fetch(API_URL, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(historyData),
    });

    if (!response.ok) {
      throw new Error("Failed to add history");
    }

    return await response.json();
  } catch (error) {
    console.error("Error adding history:", error);
    throw error;
  }
};

// Xóa bản ghi lịch sử
export const deleteHistory = async (historyId) => {
  try {
    const token = getToken();
    if (!token) {
      throw new Error("No authentication token found");
    }

    const response = await fetch(`${API_URL}/${historyId}`, {
      method: "DELETE",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      throw new Error("Failed to delete history");
    }

    return await response.json();
  } catch (error) {
    console.error("Error deleting history:", error);
    throw error;
  }
};

// Constants cho ChangeType
export const CHANGE_TYPES = {
  CREATE: "CREATE",
  UPDATE: "UPDATE",
  DELETE: "DELETE",
  STATUS_CHANGE: "STATUS_CHANGE",
  COMPLETION_UPDATE: "COMPLETION_UPDATE",
  CONVERT_TO_PARENT: "CONVERT_TO_PARENT",
  MOVE_ITEM: "MOVE_ITEM",
};

// Function để get display name cho change type
export const getChangeTypeDisplayName = (changeType) => {
  switch (changeType) {
    case CHANGE_TYPES.CREATE:
      return "Tạo mới";
    case CHANGE_TYPES.UPDATE:
      return "Cập nhật";
    case CHANGE_TYPES.DELETE:
      return "Xóa";
    case CHANGE_TYPES.STATUS_CHANGE:
      return "Thay đổi trạng thái";
    case CHANGE_TYPES.COMPLETION_UPDATE:
      return "Cập nhật tiến độ";
    case CHANGE_TYPES.CONVERT_TO_PARENT:
      return "Chuyển thành hạng mục cha";
    case CHANGE_TYPES.MOVE_ITEM:
      return "Di chuyển hạng mục";
    default:
      return changeType;
  }
};

// Function để get icon cho change type
export const getChangeTypeIcon = (changeType) => {
  switch (changeType) {
    case CHANGE_TYPES.CREATE:
      return "➕";
    case CHANGE_TYPES.UPDATE:
      return "✏️";
    case CHANGE_TYPES.DELETE:
      return "🗑️";
    case CHANGE_TYPES.STATUS_CHANGE:
      return "🔄";
    case CHANGE_TYPES.COMPLETION_UPDATE:
      return "📊";
    case CHANGE_TYPES.CONVERT_TO_PARENT:
      return "🌳";
    case CHANGE_TYPES.MOVE_ITEM:
      return "🔀";
    default:
      return "📝";
  }
};

// Function để get color cho change type
export const getChangeTypeColor = (changeType) => {
  switch (changeType) {
    case CHANGE_TYPES.CREATE:
      return "#4caf50"; // green
    case CHANGE_TYPES.UPDATE:
      return "#2196f3"; // blue
    case CHANGE_TYPES.DELETE:
      return "#f44336"; // red
    case CHANGE_TYPES.STATUS_CHANGE:
      return "#ff9800"; // orange
    case CHANGE_TYPES.COMPLETION_UPDATE:
      return "#9c27b0"; // purple
    case CHANGE_TYPES.CONVERT_TO_PARENT:
      return "#607d8b"; // blue grey
    case CHANGE_TYPES.MOVE_ITEM:
      return "#795548"; // brown
    default:
      return "#757575"; // grey
  }
};
